import * as Sentry from "@sentry/browser";
import { displayToasts, successToast } from "./common/toasts/displayToasts";

export function copyLink(buttonSelector, linkSelector) {
	const buttons = document.querySelectorAll(buttonSelector);

	if (buttons.length > 0) {
		buttons.forEach((button) => {
			const textToCopy = linkSelector(button);
			const textTrimmed = textToCopy.startsWith("mailto:")
				? textToCopy.substring(7)
				: textToCopy;

			button.addEventListener("click", async () => {
				await navigator.clipboard.writeText(textTrimmed).then(
					() => {
						displayToasts([
							successToast("Link successfully copied."),
						]);
					},
					(error) => {
						Sentry.captureException(error);
					},
				);

				button.blur();
			});
		});
	}
}
